import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken } from '../../../utils/response';
import { Token, UserCode, Company, EmployeeCode } from '../../../utils/users';
import { errorResponse } from '../../../utils/response';
import { IsEnglish } from '../../../utils/language';

export function listCorporateCreditCard(date) {
    let url = 'expenseAccount/corporateCreditCards?' + objectToQueryString({ company: Company(), userCode: UserCode(), date: date, employeeCode: EmployeeCode(), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let corporateCreditCards = response.corporateCreditCards;

                //saveCorporateCreditCards(corporateCreditCards);

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function sortCorporateCreditCards(data) {
    return data.sort(function (a, b) {
        const nameA = IsEnglish() ? a.englishDescription.toLowerCase() : a.frenchDescription.toLowerCase()
        const nameB = IsEnglish() ? b.englishDescription.toLowerCase() : b.frenchDescription.toLowerCase()
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

export function sortCorporateCreditCardsByCode(data) {
    return data.sort(function (a, b) {
        const nameA = a.creditCardType
        const nameB = b.creditCardType
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

function saveCorporateCreditCards(config) {
    //localStorage.setItem('corporateCreditCards', JSON.stringify(config));
}